import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/cost-management/employee-cost`;

export const employeeCostManagementRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create/:employeeId`,
  edit: `${baseRoute}/edit/:costId`,
  paymentHistory: `${baseRoute}/payment-history/:employeeId`,
} as const;

export type IEmployeeCostManagementRouteParams = IExtractRouteParamMap<
  typeof employeeCostManagementRoutesObj
>;

export const employeeCostManagementPath = createPaths<
  typeof employeeCostManagementRoutesObj,
  IEmployeeCostManagementRouteParams
>(employeeCostManagementRoutesObj);
